import Icons from "@/assets/icons"
import Button from "./Button";

const NotFound = () => {
  return (
    <div className='h-screen w-screen flex gap-12 items-center justify-center'>
        <Icons.FileNotFound width="200px" height="200px" pathStyle="fill-neutro-500"/>

        <div>
            <h1 className='text-8xl font-bold text-neutro-500 mb-6'>403</h1>
            <h2 className='text-5xl font-bold text-neutro-500 mb-2'>Página não encontrada</h2>
            <p className='text-2xl max-w-180 text-neutro-400 mb-10'>A página que você tentou acessar não existe, foi removida ou você não tem permissão para visualizá-la.</p>
            <Button 
                color="primario"
                label="Ir para a página inicial"
                path="/"
            />
        </div>
    </div>
  )
}

export default NotFound